// Display name for an interpreter anywhere in the ADMIN portal.
// Client rule (Aug 2026): show the AOC Roster name (`display_name`) — many imported
// interpreters have no first_name, so first_name-based labels render blank/broken.
// Fallback chain never yields blank: zero rows have both display_name and first/last empty.
// Accepts an Interpreter model object (optionally with a nested `user`).
export const interpreterName = (i) => {
  if (!i) return "";
  const roster = (i.display_name || "").trim();
  if (roster) return roster;
  const full = `${i.first_name || ""} ${i.last_name || ""}`.trim();
  return full || i.user?.name || "";
};
